export const STICKY_BUTTON_TOP = 48;

export const LOADING_OFFSET = 62;

export const LOADING_THROTTLING_MS = 50;
